import { useEffect, useRef } from "react";

/**
 * 
 * @param {String} type Type of event eg. "click"
 * @param {Function} callback Function to call whenever event triggers
 * @param {HTMLElement | ReactComponent | null} element Element to listen for event on, defaults to window
 */
export default function useEventListener(type, callback, element = window) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    element.addEventListener(type, callback);
    return () => {
      element.removeEventListener(type, callback);
    };
  }, [type, callback, element]);
}
